export enum DeviceDirection {
  IN = 'IN',
  OUT = 'OUT',
  INFO = 'INFO',
}
